/**
 * Resolve the order Mongo id from a notification (relatedId or link path/query).
 */
export function getNotificationRelatedOrderId(notification) {
  if (!notification) return "";
  const related = notification.relatedId;
  if (related != null && related !== "") {
    if (typeof related === "object" && related._id) {
      return String(related._id);
    }
    const asString = String(related);
    if (asString && asString !== "[object Object]") return asString;
  }
  const link = String(notification.link || "");
  const pathMatch = link.match(
    /\/profile\/(?:order|seller-order)\/([a-fA-F0-9]{24})/
  );
  if (pathMatch?.[1]) return pathMatch[1];
  const queryMatch = link.match(/[?&]order=([a-fA-F0-9]{24})/);
  return queryMatch?.[1] || "";
}

function linkTargetsSellerRefundReview(link = "") {
  const l = String(link || "");
  return (
    l.includes("/profile/seller-order/") ||
    l.includes("tab=review-refunds")
  );
}

function linkTargetsBuyerPurchase(link = "") {
  const l = String(link || "");
  if (linkTargetsSellerRefundReview(l)) return false;
  return (
    l.includes("/profile/order/") ||
    l.includes("tab=my-refunds") ||
    l.includes("/profile/inbox")
  );
}

/** Seller-only refund/dispatch types (never buyer My Refunds). */
const SELLER_ONLY_NOTIFICATION_TYPES = new Set([
  "order_dispatch_reminder",
  "order_dispatch_due_today",
  "return_in_transit",
  "order_refund",
]);

/** Buyer purchase updates (not seller sales / dispatch / buyer-refunds review). */
export function isBuyerFacingOrderNotification(notification) {
  if (!notification) return false;
  const link = String(notification.link || "");
  if (linkTargetsSellerRefundReview(link)) return false;
  const type = String(notification.type || "");
  if (SELLER_ONLY_NOTIFICATION_TYPES.has(type)) return false;
  return true;
}

/** Seller sales / dispatch / buyer-refunds review updates. */
export function isSellerFacingOrderNotification(notification) {
  if (!notification) return false;
  const link = String(notification.link || "");
  if (linkTargetsSellerRefundReview(link)) return true;
  const type = String(notification.type || "");
  return SELLER_ONLY_NOTIFICATION_TYPES.has(type);
}

/** Buyer My Refunds tab / purchase refund alerts. */
export function isBuyerFacingRefundNotification(notification) {
  if (!notification) return false;
  const link = String(notification.link || "");
  if (linkTargetsSellerRefundReview(link)) return false;
  const type = String(notification.type || "");
  if (type === "return_in_transit" || type === "order_refund") return false;
  // Prefer explicit buyer links when present
  if (link && !linkTargetsBuyerPurchase(link) && link.includes("/profile/")) {
    // Unknown profile link that isn't buyer purchase — exclude
    if (linkTargetsSellerRefundReview(link)) return false;
  }
  return true;
}

/** Seller Buyer Refunds tab alerts. */
export function isSellerFacingRefundNotification(notification) {
  if (!notification) return false;
  const link = String(notification.link || "");
  if (linkTargetsSellerRefundReview(link)) return true;
  const type = String(notification.type || "");
  return type === "return_in_transit" || type === "order_refund";
}
